export default __webpack_public_path__ + "static/media/BX.54478365.png";